import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// Global routes
export const globalIntegrationCreateRoute: InvariantJiraRoute = {
	name: 'eoc-integration-create',
	path: '/jira/settings/products/ops/integrations/create/:type',
	exact: true,
};
